/* eslint-disable camelcase */
import axios from 'axios';
import { resortConfig } from './data/resort.config';

export default {
  async getResortInfo({ commit, getters }) {
    const resortUrl = `${getters.baseUrl}?resortId=${resortConfig.resort_id}`;

    try {
      const response = await axios.get(resortUrl);
      commit('POPULATE_RESORT', response.data);
    } catch (error) {
      commit('API_FAILURE', error);
    }
  },
  async getResortLifts({ commit, getters }) {
    const resortUrl = `${getters.baseUrl}/${resortConfig.resort_id}/lifts`;

    try {
      const response = await axios.get(resortUrl);
      commit('POPULATE_LIFTS', response.data);
    } catch (error) {
      commit('API_FAILURE', error);
    }
  },
  async getWeather({ commit, getters }) {
    const resortUrl = `${getters.baseUrl}/${resortConfig.resort_id}/weather`;

    try {
      const response = await axios.get(resortUrl);
      commit('POPULATE_WEATHER', response.data);
    } catch (error) {
      commit('API_FAILURE', error);
    }
  },
  async getWebcams({ commit, getters }) {
    const webcamsUrl = `${getters.baseUrl}/${resortConfig.resort_id}/webcams`;

    try {
      const response = await axios.get(webcamsUrl);
      commit('POPULATE_WEBCAMS', response.data);
    } catch (error) {
      commit('API_FAILURE', error);
    }
  },
  async getSnowfallChartData({ commit, getters }) {
    const snowfallUrl = `${getters.baseUrl}/${resortConfig.resort_id}/snowfall/chart.json`;

    try {
      const response = await axios.get(snowfallUrl);
      commit('POPULATE_SNOWFALL_DATA', response.data);
    } catch (error) {
      commit('API_FAILURE', error);
    }
  },
  // true or false for showing Total Snowfall in Chart
  setTotalSnowfall({ commit }, setting) {
    commit('SET_SNOWFALL_SHOWN', setting);
  },
  // true or false for cm / in in Snowfall Chart
  setSnowfallMetric({ commit }, setting) {
    commit('SET_SNOWFALL_METRIC', setting);
  },
  setSnowfallTimeRange({ commit }, setting) {
    commit('SET_SNOWFALL_TIME_RANGE', setting);
  },
  setWeatherUnits({ commit }, units) {
    for (const unit of Object.keys(units)) {
      commit(`SET_${unit.toUpperCase()}`, units[unit]);
    }
  },
};
